import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
const OrderOption = (t0) => {
    const $ = _c(6);
    const { option } = t0;
    const translate = useTranslate();
    const t1 = `list_order.${option}`;
    let t2;
    if ($[0] !== t1 || $[1] !== translate) {
        t2 = translate(t1);
        $[0] = t1;
        $[1] = translate;
        $[2] = t2;
    }
    else {
        t2 = $[2];
    }
    const label = t2;
    let t3;
    if ($[3] !== label || $[4] !== option) {
        t3 = <option value={option} className="!text-right">
      {label}
    </option>;
        $[3] = label;
        $[4] = option;
        $[5] = t3;
    }
    else {
        t3 = $[5];
    }
    return t3;
};
export default OrderOption;
